module.exports = __webpack_public_path__ + "LGFacad_2.98b65b38.png";